export function getFormatted(text: number) {
  return (
    '00:' +
    text.toLocaleString('it-IT', {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })
  );
}
